"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.renderAppBasePlatformNotFoundPage = renderAppBasePlatformNotFoundPage;
exports.renderAppBasePlatformNoAccessPage = renderAppBasePlatformNoAccessPage;
const app_base_portal_page_text_1 = require("./app-base-portal-page-text");
const html_escape_1 = require("./html-escape");
/** The words of the plain platform pages, by page and language. */
const TEXT = {
    notFound: {
        de: {
            title: 'Seite nicht gefunden',
            body: 'Diese Seite gibt es hier nicht.',
            link: 'Zur Startseite',
        },
        en: {
            title: 'Page not found',
            body: 'There is no such page here.',
            link: 'Go to the start page',
        },
    },
    noAccess: {
        de: {
            title: 'Kein Zugriff',
            body: 'Du bist angemeldet, hast aber keinen Zugriff auf diese Seite.',
            link: 'Zur Startseite',
        },
        en: {
            title: 'No access',
            body: 'You are signed in but have no access to this page.',
            link: 'Go to the start page',
        },
    },
};
/**
 * The page StreamLain answers with status 404 for an address that names no
 * page or no row, when the App of its place brings no not-found page or the
 * visitor may not open that App: in German for a German `locale`, else in
 * English, with a link to `startHref`. The server and the StreamKit send the
 * same page.
 */
function renderAppBasePlatformNotFoundPage(input) {
    return renderAppBasePlatformPage('notFound', input);
}
/**
 * The page StreamLain answers with status 403 when a signed-in portal person
 * opens a page whose page rights do not open it for the portal. A visitor who
 * is not signed in gets the sign-in instead.
 */
function renderAppBasePlatformNoAccessPage(input) {
    return renderAppBasePlatformPage('noAccess', input);
}
function renderAppBasePlatformPage(page, input) {
    const lang = (0, app_base_portal_page_text_1.appBasePlatformPageLanguage)(input.locale);
    const text = TEXT[page][lang];
    return `<!doctype html>
<html lang="${lang}">
<head>
  <meta charset="utf-8">
  <meta name="viewport" content="width=device-width, initial-scale=1">
  <meta name="robots" content="noindex">
  <title>${(0, html_escape_1.escapeHtml)(text.title)} - ${(0, html_escape_1.escapeHtml)(input.title)}</title>
  <style>
    html{font-family:Inter,ui-sans-serif,system-ui,-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif;background:#f7f8fa;color:#18202a}
    body{margin:0;min-height:100vh;display:grid;place-items:center;padding:24px}
    main{width:min(420px,100%);background:#fff;border:1px solid #d8dee8;border-radius:8px;padding:28px}
    h1{font-size:22px;line-height:1.2;margin:0 0 12px}
    p{color:#526071;line-height:1.5;margin:0 0 20px}
    a{color:#1f6feb;font-weight:600}
  </style>
</head>
<body>
  <main>
    <h1>${(0, html_escape_1.escapeHtml)(text.title)}</h1>
    <p>${(0, html_escape_1.escapeHtml)(text.body)}</p>
    <a target="_top" href="${(0, html_escape_1.escapeHtml)(input.startHref)}">${(0, html_escape_1.escapeHtml)(text.link)}</a>
  </main>
</body>
</html>`;
}
